import React, {FC, useLayoutEffect, useState} from 'react';

import domService from '../../services/domService';
import helpers from '../../utils/helpers';
import AppPopup from './AppPopup';
import useOneModalOnPageAtATime from './useOneModalOnPageAtATime';

interface IProps {
    contentLabel?: string;
    testId?: string;
    className?: string;
    overlayClassName?: string;
    onClose?: () => void;
    isCloseVisible?: boolean;
    closeButtonAriaLabel?: string;
    children?: React.ReactNode;
}

const PopupFullPage: FC<IProps> = (props) => {
    const {className, ...restProps} = props;
    const isVisible = useOneModalOnPageAtATime();
    const [myRef, setMyRef] = useState<HTMLDivElement | null>(null);

    const onRefChange = (node: HTMLDivElement) => setMyRef(node);

    useLayoutEffect(() => {
        if (myRef) {
            const rootEl = domService.getRoot();
            const heightValue = myRef.offsetTop - rootEl.offsetTop;

            window.scrollTo(0, heightValue);
        }
    }, [myRef]);

    if (!isVisible) return null;

    return (
        <AppPopup
            {...restProps}
            bodyOpenClassName='modal__Body--open'
            overlayClassName='block relative bg-none'
            isOpen
            className={className}
            contentRef={onRefChange}
            onAfterClose={() => {
                helpers.scrollTop();
            }}
        />
    );
};

export default PopupFullPage;
